import { render, staticRenderFns } from "./StatusClaimTask.vue?vue&type=template&id=4db71487&scoped=true&"
import script from "./StatusClaimTask.vue?vue&type=script&lang=ts&"
export * from "./StatusClaimTask.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db71487",
  null
  
)

export default component.exports